export default "__VITE_ASSET__5406615e__"